import React from "react";
import classes from "../../Landing/Landing.module.scss";
export default function SmartSolar() {
  const plans = [
    { img: "https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1767075680/InShot_20251230_114946501_zzsuuv.jpg" },
    { img: "https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1767075680/InShot_20251230_114359998_nlauhj.jpg" },
    { img: "https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1767076631/InShot_20251230_114104098_vzh9m8.jpg" },
  ];

  return (
    <>
      {/* <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-3 gap-4">
        {plans.map((p, i) => (
            <img src={p.img} className="mt-4 w-full h-70 object-contain rounded-xl" />
        ))}
      </div> */}
  <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-4">
    {plans.map((p, i) => (
      <div key={i} className="w-full">
        <img 
          src={p.img} 
          alt={p.title || `Mahi Dental Clinic dental treatment plan ${i + 1}`} 
          className="w-full h-auto object-cover md:rounded-xl" 
        />
      </div>
    ))}
  </div>
    </>
  );
}
